import { injectIntl } from 'react-intl';

const GroupThirdParty = ({ intl }) => {
  if (intl.locale === 'en') {
    return (
      <>
        <div className="mb-base">
          The gov.br portal depends on services offered by third parties that
          allow:
        </div>
        <ul>
          <li>Improve government information campaigns;</li>
          <li>Offer interactive content;</li>{' '}
          <li>
            Improve usability and facilitate the sharing of content on social
            networks;
          </li>
          <li>Watch videos and animated presentations directly on gov.br.</li>
        </ul>
        <div className="mb-base">
          Third-party cookies on the govb.br portal are all Google advertising
          and multimedia cookies. These third parties will collect and use
          browsing data also for their own purposes.
        </div>
        <div className="mb-base">
          The user can deactivate them directly on the Google website.
        </div>
        <ul>
          <li>
            Official information on Google's third party cookies (
            <a
              href="https://business.safety.google/adscookies"
              target="_blank"
              rel="noreferrer"
            >
              https://business.safety.google/adscookies
            </a>
            ).
          </li>
          <li>
            Google Policy (
            <a
              href="https://policies.google.com/technologies/partner-sites?hl-pt-BR"
              target="_blank"
              rel="noreferrer"
            >
              https://policies.google .com/technologies/partner-sites?hl-pt-BR
            </a>
            ).
          </li>
        </ul>
        <div className="mb-base">
          Google Analytics on the gov.br portal has advertising reporting
          features enabled, which collects information per DoubleClick cookie,
          such as web activity and device advertising IDs (application
          activity)(
          <a
            href="https://support.google.com/analytics/answer/2799357"
            target=" _blank"
            rel="noreferrer"
          >
            https://support.google.com/analytics/answer/2799357
          </a>
          )
        </div>
        <div className="mb-base">
          The gov.br portal has no control over which third-party cookies will
          be activated.
        </div>
        <div className="mb-base">
          Some third-party cookies that may be found when accessing the portal:
        </div>
        <div>Domains: Google, Youtube, DoubleClick.net</div>
      </>
    );
  }

  return (
    <>
      <div className="mb-base">
        O portal gov.br depende dos serviços oferecidos por terceiros que
        permitem:
      </div>
      <ul>
        <li>Melhorar as campanhas de informação do governo;</li>
        <li>Oferecer conteúdo interativo;</li>
        <li>
          Melhorar a usabilidade e facilitar o compartilhamento de conteúdo nas
          redes sociais;
        </li>
        <li>
          Assistir a vídeos e apresentações animadas diretamente no gov.br.
        </li>
      </ul>
      <div className="mb-base">
        Os cookies de terceiros no portal gov.br são todos cookies de
        publicidade e multimídia do Google. Esses terceiros coletarão e usarão
        dados de navegação também para seus próprios fins.
        <div className="mb-base">
          O usuário pode desativá-los direto no site da Google.
        </div>
      </div>
      <ul>
        <li>
          Informativo oficial dos cookies de terceiros do Google (
          <a
            href="https://business.safety.google/adscookies"
            target="_blank"
            rel="noreferrer"
          >
            https://business.safety.google/adscookies
          </a>
          ).
        </li>
        <li>
          Política do Google (
          <a
            href="https://policies.google.com/technologies/partner-sites?hl-pt-BR"
            target="_blank"
            rel="noreferrer"
          >
            https://policies.google.com/technologies/partner-sites?hl-pt-BR
          </a>
          ).
        </li>
      </ul>
      <div className="mb-base">
        O Google Analytics no portal gov.br tem recursos de relatórios de
        publicidade ativados, que coleta informações adicionais por cookie da
        DoubleClick, como atividade da Web e de IDs de publicidade do
        dispositivo (atividade do aplicativo) (
        <a
          href="https://support.google.com/analytics/answer/2799357"
          target="_blank"
          rel="noreferrer"
        >
          https://support.google.com/analytics/answer/2799357
        </a>
        )
      </div>
      <div className="mb-base">
        O portal gov.br não tem controle sobre quais cookies de terceiros serão
        ativados.
      </div>
      <div className="mb-base">
        Alguns cookies de terceiros que podem ser encontrados ao acessar o
        portal:
      </div>
      <div>Domínios: Google, Youtube, DoubleClick.net</div>
    </>
  );
};

export default injectIntl(GroupThirdParty);
